<template>
  <div id="roadSideCarTurnover">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>路侧数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>周转率报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期::">
            <el-date-picker v-model="fDate"
                            style="width:150px"
                            type="month"
                            :clearable="false"
                            placeholder="请选额日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           prop="fIndex"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fMonthDays"
                           align="right"
                           label="月份天数">
          </el-table-column>
          <el-table-column prop="fParkPlaceNum"
                           align="right"
                           label="泊车位">
          </el-table-column>
          <el-table-column prop="fPayNum"
                           align="right"
                           label="泊车收费笔数">
          </el-table-column>
          <el-table-column prop="fTurnoverRate"
                           align="right"
                           label="周转率">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { report as api } from '../../../api/roadSideReport'
import * as park from '../../../api/park'
import * as user from '../../../api/user'
export default {
  data () {
    return {
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      fDate: '',
      pageSearch: {
        fCustID: '',
        fIsExport: false,
        fDate: ''
      }
    }
  },
  methods: {
    page_list (index) {
      this.loading = true
      this.pageSearch.fDate = this.fDate
      if (this.fDate instanceof Date) {
        this.pageSearch.fDate = this.$dateFormat(this.fDate, 'yyyy-MM-dd')
      }

      this.pageSearch.fIsExport = false
      api.carTurnoverList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      if ((this.pageSearch.fDate || '').trim().length <= 0) {
        this.$message.error('提示：请先选择日期')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      this.pageSearch.fDate = this.fDate
      if (this.fDate instanceof Date) {
        this.pageSearch.fDate = this.$dateFormat(this.fDate, 'yyyy-MM-dd')
      }
      var fileName = this.pageSearch.fDate.substring(0, 7) + '_' + (custArr.length > 0 ? custArr[0].unionName : '')
      this.pageSearch.fIsExport = true
      api.carTurnoverList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_周转率报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    changePark () {
      // 加载离场数据列表
      this.page_list()
    },
    init () {
      park.getCustByGroup({ fCustTypeID: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data || []
            if (this.cust_list.length > 0) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    // handleInfo (index, row) {
    //   this.dialogFormVisible = true
    //   this.usrExgData.loading = false

    //   this.dialogTitle = ((row.fParkName || '').trim(), length <= 0 ? '' : ('【' + row.fParkName + '】')) + '交班明细数据' + '（' + row.fOuterName.split('】')[1] + '）'
    //   this.userExgSearch.fCustID = row.fCustID
    //   this.userExgSearch.fExgID = row.fExgID
    //   this.userExgSearch.type = row.fBigRowID

    //   this.usrExgData.fOpLastTime = row.fOpLastTime
    //   this.usrExgData.fUserName = row.fUserName
    //   this.usrExgData.fBatStartTime = row.fBatStartTime
    //   this.usrExgData.fBatEndTime = row.fBatEndTime
    //   this.usrExgData.fParkName = row.fParkName
    //   this.usrExgData.fBigRowID = '0'
    //   this.usrExgData.fCustName = ''
    //   this.cust_his_data = []
    //   this.usr_exg_data = []
    //   this.pay_data = []
    //   this.cust_his_data_count = 0
    //   api.handoverInfo({ fCustID: row.fCustID, fExgID: row.fExgID }).then(res => {
    //     if (res && res.data) {
    //       var data = res.data
    //       if (data.IsOk) {
    //         this.usr_exg_data = data.Data || []
    //         if (this.usr_exg_data.length > 0) {
    //           if ((this.usr_exg_data[0].fCustName || '').trim().length > 0) {
    //             this.dialogTitle = '【' + this.usr_exg_data[0].fCustName + '】交班明细数据'
    //             this.usrExgData.fCustName = this.usr_exg_data[0].fCustName
    //           }
    //         }
    //       } else {
    //         this.$message.error('提示：' + data.Msg)
    //       }
    //     }
    //   })
    //   this.page_exg_list()
    // },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 210
      obj.tableHeight = clientHeight
    }
  },
  created () {
    var today = new Date()
    this.fDate = today.getFullYear() + '-' + (today.getMonth() + 1)

    user.getCurrentUserPers({ perTypeId: 170000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.title-row {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/roadSidePark/report/roadSideCarTurnover.vue